import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";
import statusHttpRequest from "../../utils/statusHttpRequest";

const initialState = {
  loading: false,
  error: null,
  registerIndividual: [],
  personalInfo: "",
  employmentInfo: "",
  // qualificationInfo: "",
  educationHistories: [],
  marriageRefInfo: "",
  refereeInfo: "",
};

export const createIndividualRegistration = createAsyncThunk(
  "individualRegistration/createIndividualRegistration",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Application/individual-registration`,
        "post",
        arg
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createIndividualApplicationForm = createAsyncThunk(
  "individualRegistration/createIndividualApplicationForm",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Application/individual-application-form`,
        "post",
        arg
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const editIndividualApplicationForm = createAsyncThunk(
  "individualRegistration/updateIndividualApplicationForm",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Application/individual/update`,
        "post",
        arg
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchIndividualApplication = createAsyncThunk(
  "individualRegistration/fetchIndividualApplication",
  async () => {
    return statusHttpRequest(
      `${BASE_URL}/v2/Application/individual-application`
    );
  }
);

const individualRegistrationSlice = createSlice({
  name: "individualRegistration",
  initialState,
  reducers: {
    setPersonalInfo: (state, { payload }) => {
      state.personalInfo = payload;
    },
    setEmploymentInfo: (state, { payload }) => {
      state.employmentInfo = payload;
    },
    // setQualificationInfo: (state, {payload}) => {
    //   state.qualificationInfo = payload;
    // },
    setMarriageRefInfo: (state, { payload }) => {
      // console.log('payload' ,payload)
      state.marriageRefInfo = payload;
    },
    // setRefereeInfo: (state, {payload}) => {
    //   state.marriageRefInfo = payload;
    // },

    setEducationHistories: (state, { payload }) => {
      state.educationHistories = payload;
    },
  },

  extraReducers: (builder) => {
    // Register Individual:
    builder.addCase(createIndividualRegistration.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      createIndividualRegistration.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.error = null;
      }
    );
    builder.addCase(
      createIndividualRegistration.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );

    // Create Individual Application Form:
    builder.addCase(createIndividualApplicationForm.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      createIndividualApplicationForm.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.error = null;
      }
    );
    builder.addCase(
      createIndividualApplicationForm.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );

    // get Individual Application Form:
    builder.addCase(fetchIndividualApplication.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchIndividualApplication.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.registerIndividual = payload;
        state.error = null;
      }
    );
    builder.addCase(
      fetchIndividualApplication.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );
  },
});

export const {
  setPersonalInfo,
  setEmploymentInfo,
  setMarriageRefInfo,
  setEducationHistories,
} = individualRegistrationSlice.actions;
export default individualRegistrationSlice.reducer;
